module.exports = __webpack_public_path__ + "static/media/dice-six.3aa9af27.svg";